export const SET_SELECTED_STATE_LAW_DEFAULT = 'SET_SELECTED_STATE_LAW_DEFAULT'
export const SET_SELECTED_STATE_LAW = 'SET_SELECTED_STATE_LAW'
export const ADD_ALLOWED_ITEMS = 'ADD_ALLOWED_ITEMS'
export const REMOVE_ALLOWED_ITEMS = 'REMOVE_ALLOWED_ITEMS'
export const ADD_PROOF_ALLOWED_ITEMS = 'ADD_PROOF_ALLOWED_ITEMS'
export const REMOVE_PROOF_ALLOWED_ITEMS = 'REMOVE_PROOF_ALLOWED_ITEMS'




// WEBPACK FOOTER //
// ./src/store/modules/statelaws/mutation-types.js